<template>
  <header id="header-component">
    <DxToolbar>
      <DxItem widget="dxButton"
              location="before"
              :cssClass="drawerCollapseStates.left ? null : 'hidden-button'"
              :options="{ icon: 'panelleft' }"
              @click="collapseDrawer('left')"
      />

      <DxItem location="before">
          <router-link class="cabinet-links" :to="{ name: 'cabinets' }">
            <img id="logo" :src="factzLogo"/>
          </router-link>
      </DxItem>

      <DxItem location="before">
          <CabinetsDropdown/>
      </DxItem>

      <DxItem location="before" v-show="isAdmin">
          <router-link :to="{ name: 'admin' }" class="admin-link">
            <span class="material-symbols-outlined dx-icon"> admin_panel_settings </span>
            Admin
          </router-link>
      </DxItem>

      <DxItem location="center" v-if="isCabinet">
        <CabinetHeader/>
      </DxItem>

      <DxItem location="after">
          <TryNewVersionHeaderButton/>
      </DxItem>

      <DxItem location="after">
          <NotificationButton/>
      </DxItem>

      <DxItem location="after">
          <UsersnapHeaderButton/>
      </DxItem>

      <DxItem location="after">
          <AccountDropdown/>
      </DxItem>

      <DxItem widget="dxButton"
              location="after"
              :cssClass="drawerCollapseStates.right ? null : 'hidden-button'"
              :options="{ icon: 'panelright' }"
              @click="collapseDrawer('right')"
      />
    </DxToolbar>
  </header>
</template>


<script setup>
  import { onMounted } from "vue";
  import { storeToRefs } from "pinia";
  import CabinetsDropdown from "@/components/base-components/header/CabinetsDropdown.vue";
  import CabinetHeader from "@/components/base-components/header/CabinetHeader.vue";
  import NotificationButton from "@/components/base-components/header/NotificationButton.vue";
  import TryNewVersionHeaderButton from "@/components/base-components/header/TryNewVersionHeaderButton.vue";
  import UsersnapHeaderButton from "@/components/base-components/header/UsersnapHeaderButton.vue";
  import AccountDropdown from "@/components/base-components/header/AccountDropdown.vue";
  import factzLogo from '@/images/Factz_logo_green.svg'
  import { DxToolbar, DxItem } from 'devextreme-vue/toolbar'
  import { useHeaderStore } from "@/stores/headerStore.js";
  import { useUserStore } from "@/stores/userStore.js";

  const headerStore = useHeaderStore()
  const { drawerCollapseStates } = storeToRefs(headerStore)

  const userStore = useUserStore()
  const { isAdmin } = storeToRefs(userStore)

  const isCabinet = true

  const collapseDrawer = (position) => {
    drawerCollapseStates.value[position] ? drawerCollapseStates.value[position] = false : drawerCollapseStates.value[position] = true
  }

  headerStore.getRecentCabinetList()
  headerStore.getNotifications()
</script>

<style lang="scss">
  @import url("https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20,275,0,0&icon_names=admin_panel_settings");

  .hidden-button {
    visibility: hidden;
  }

  #header-component {
    position: sticky;
    top: 0;
    * {
      font-size: 1rem;
      font-weight: normal;
      color: $white-normal;

      .dx-icon {
        font-size: 1.25rem;
      }
    }

    .dx-toolbar {
      background-color: $la-new-dark-blue;

      #logo {
        height: 1.3rem;
        margin: 0.1rem 0.6rem 0.3rem 0.45rem;
      }

      .dx-toolbar-items-container {
        align-items: stretch;

        .dx-toolbar-after, .dx-toolbar-before {
          .dx-toolbar-item:focus-within, .dx-toolbar-item:hover {
            background-color: $blue-opac;
          }

          .dx-toolbar-item {
            padding-inline-start: 0;
            padding-inline-end: 0;
          }
        }

        .dx-button.dx-state-focused, .dx-button.dx-state-hover {
          background-color: transparent;
        }

        .dx-toolbar-center {
          .dx-toolbar-item,
          .dx-toolbar-item .dx-item-content,
          .dx-toolbar-item .dx-button {
            height: 100%;
            border-radius: 0 !important;
            box-shadow: none;
          }

          .dx-toolbar-item .dx-button:hover,
          .dx-toolbar-item .dx-button:focus-within {
            background-color: $blue-opac !important;
          }
        }

        .dx-toolbar-item .dx-button-content {
            padding: 0;
          }

        .dx-state-hover {
          background-color: unset;
        }
      }

      .material-symbols-outlined {
        margin-right: 0.25rem;
      }

      a.admin-link{
        cursor: pointer;
        display: flex;
        align-items: center;
        margin: 0 0.5rem 0 0.25rem;
      }
    }
  }
</style>
